import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';

import Button, { IconButton, SubButton, OutlineButton, TextButton } from 'components/Button';
import TextInput from 'components/forms/TextInput';

class StyleGuide extends React.Component {
  render() {
    return (
      <div className="content styleguide">
        
        <div className="section">
          <div className="title">Buttons</div>
          <div className="section-items row">
            <div className="btn-list column">
              <Button size="xs">Button XSmall</Button>
              <Button size="s">Button Small</Button>
              <Button>Button</Button>
              <Button size="l">Button Large</Button>
              <Button size="xl">Button XLarge</Button>
            </div>
            <div className="btn-list column">
              <SubButton size="xs">Button XSmall</SubButton>
              <SubButton size="s">Button Small</SubButton>
              <SubButton size="m">Button Med</SubButton>
              <SubButton size="l">Button Large</SubButton>
              <SubButton size="xl">Button XLarge</SubButton>
            </div>
            <div className="btn-list column">
              <Button icon="pencil" size="xs">XS Icon</Button>
              <Button icon="pencil" size="xs" position="right">XS Right Icon</Button>

              <Button icon="pencil" size="s">S Icon</Button>
              <Button icon="pencil" size="s" position="right">S Right Icon</Button>
              
              <Button icon="pencil">Icon</Button>
              <Button icon="pencil" position="right">Right Icon</Button>

              <Button icon="pencil" size="l">L Icon</Button>
              <Button icon="pencil" size="l" position="right">L Right Icon</Button>
              
            </div>
            <div className="btn-list column">
              <OutlineButton size="xs">Button XSmall</OutlineButton>
              <OutlineButton size="s">Button Small</OutlineButton>
              <OutlineButton size="m">Button</OutlineButton>
              <OutlineButton size="l">Button Large</OutlineButton>
              <OutlineButton size="xl">Button XLarge</OutlineButton>
            </div>
            <div className="btn-list column">
              <TextButton icon="pencil" size="xs">Text Button: XS</TextButton>
              <TextButton icon="pencil" size="s">Text Button: S</TextButton>
              <TextButton icon="pencil" size="m">Text Button: M</TextButton>
              <TextButton icon="pencil" size="l">Text Button: L</TextButton>
              <TextButton icon="pencil" size="xl">Text Button: XL</TextButton>
            </div>
            <div className="btn-list column">
              <Button href="/" icon="pencil" size="xs">Link XSmall</Button>
              <Button href="/" icon="pencil" size="s">Link Small</Button>
              <Button href="/" icon="pencil" size="m">Link Med</Button>
              <Button href="/" icon="pencil" size="l">Link Large</Button>
              <Button href="/" icon="pencil" size="xl">Link XLarge</Button>
            </div>
            <div className="btn-list column">
              <IconButton icon="trash" />
              <IconButton icon="ellipses" />
              <IconButton icon="pencil" />
              <IconButton icon="headphones" />
              <IconButton icon="minus" />
            </div>
          </div>
        </div>

        <div className="section">
          <div className="title">Colors</div>
          <div className="color-list">
            <div className="color-list">
              <div className="surface-group">
                <div className="surface surface-1">Surface 1</div>
                <div className="surface surface-2">Surface 2</div>
                <div className="surface surface-3">Surface 3</div>
                <div className="surface surface-4">Surface 4</div>
                <div className="surface surface-5">Surface 5</div>
                <div className="surface surface-6">Surface 6</div>
                <div className="surface surface-7">Surface 7</div>
                <div className="surface surface-8">Surface 8</div>
              </div>
            </div>
            <div className="color-group">
              <div className="color primary main">Primary</div>
              <div className="color primary-1"></div>
              <div className="color primary-2"></div>
              <div className="color primary-3"></div>
              <div className="color primary-4"></div>
              <div className="color primary-5"></div>
            </div>
            <div className="color-group">
              <div className="color secondary main">Secondary</div>
              <div className="color secondary-1"></div>
              <div className="color secondary-2"></div>
              <div className="color secondary-3"></div>
              <div className="color secondary-4"></div>
              <div className="color secondary-5"></div>
            </div>
            <div className="color-group">
              <div className="color tertiary main">Tertiary</div>
              <div className="color tertiary-1"></div>
              <div className="color tertiary-2"></div>
              <div className="color tertiary-3"></div>
              <div className="color tertiary-4"></div>
              <div className="color tertiary-5"></div>
            </div>
          </div>
        </div>
        
        <div className="section">
          <div className="title">Lines</div>
          <div className="line-list">
            <div className="box line-1"></div>
            <div className="box line-2"></div>
            <div className="box line-3"></div>
            <div className="box line-4"></div>
            <div className="box line-5"></div>
          </div>
          <div className="line-list col">
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
            <div className="line line-4"></div>
            <div className="line line-5"></div>
          </div>
          <div className="line-list col back">
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
            <div className="line line-4"></div>
            <div className="line line-5"></div>
          </div>
        </div>

        <div className="section">
          <div className="title">Forms</div>
          <div className="input-list">
            <TextInput name="test" value="Text Input" />
            <TextInput name="test" prefix="$" value="5.00 - w prefix" />
            <TextInput 
              name="test" 
              label="label" 
              value="Text Input - with Helper"
              helper="This is helper text" />
          </div>
          
        </div>
        
      </div>);
  }
}
export default StyleGuide;



